import styled, { css } from "styled-components";
import { DhlText, DhlButton } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";
import WeightSelector from "one-time-shipment/src/components/FreightItem/WeightSelector";
import {
  Headline,
  Icon,
  IconButton,
  Form,
  GridContainer,
  biDimemsionalCell,
} from "root/libs/ui-components/src";
import {
  CustomDimensionsWrapper,
  StyledQuantityColumn,
} from "../DimensionSelectorLarge/styled";
import AdvancedSettings from "../../Forms/AdvancedSettings";
import { QuantityContent } from "../../Forms/QuantitySelector/styled";
import { FreightCardWrapper } from "../styled";

const ieCheckboxButtonPadding = "60%";
const dimensionsContentGridGap = "20px";

export const ShipmentLaneFormWrapper = styled(Form)`
  padding-top: var(--dui-size-space-10x);
  padding-bottom: var(--dui-size-space-10x);

  background-color: var(--dui-color-yellow-500);
  position: relative;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-top: var(--gaq-size-space-45px);
    padding-bottom: var(--gaq-size-space-50px);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-top: var(--dui-size-space-32x);
    padding-bottom: var(--dui-size-space-10x);
  }

  .button-wrapper {
    margin-left: var(--dui-size-space-10x);
    margin-right: var(--dui-size-space-10x);

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-left: 0;
      margin-right: 0;
    }
  }

  @media print {
    padding: 0px;

    & > h2 {
      margin: 0px;
    }
  }
`;

export const StyledIconWrapper = styled.div`
  display: inline-block;
  margin: 0 var(--dui-size-space-5x) 0 0;

  svg {
    color: var(--dui-color-red-500);
    width: 52px;
    height: 52px;
  }
`;

export const ShipmentLaneHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ShipmentLandeBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CustomBackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--gaq-size-space-130px);
  background-color: var(--dui-colors-action-background-secondary-default);
  color: var(--dui-colors-action-foreground-secondary-default);
  border: var(--dui-size-space-1) solid
    var(--dui-colors-action-foreground-secondary-default);
  padding: var(--dui-size-space-7x) var(--dui-size-space-8x);
  font-size: var(--dui-size-font-md);
  border-radius: var(--dui-size-space-2x);
  cursor: pointer;
  transition: background 0.2s ease;
  font-weight: var(--dui-font-weight-bold);

  &:focus-visible {
    outline: var(--dui-size-space-1x) solid
      var(--dui-colors-action-background-primary-default);
    outline-offset: var(--dui-size-space-1x);
    z-index: 1;
  }

  &:hover {
    border-color: var(--dui-colors-action-foreground-secondary-hover);
    color: var(--dui-colors-action-foreground-secondary-hover);
    svg {
      color: var(--dui-colors-action-foreground-secondary-hover);
    }
  }

  svg {
    width: var(--dui-size-space-8x);
    height: var(--dui-size-space-8x);
    color: var(--dui-colors-action-foreground-secondary-default);
    transition: color 0.2s ease;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-top: var(--dui-size-space-10x);
  margin-right: var(--dui-size-space-10x);
  margin-left: var(--dui-size-space-10x);
  margin-bottom: var(--gaq-size-space-30px) !important;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0 0 var(--gaq-size-space-30px) 0;
  }
`;

export const ieShipmentItemGridContainer = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    max-width: 100rem;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    max-width: 100rem;
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const ShipmentItemContainer = styled.div`
  margin: var(--dui-size-space-16x) auto;
  display: flex;
  flex-direction: column;
  align-items: start;
  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
  }
  max-width: 100rem;
`;

export const ShipmentItemContainerGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: var(--dui-size-space-10x);
  &.stretch {
    align-self: stretch;
  }
`;

export const ShipmentLaneAdvancedSettings = styled(AdvancedSettings)`
  grid-area: advancedSettingsRow;
  .dhl-cj-main & {
    margin: 0 !important;
    padding-top: 0 !important;
    border: 0 !important;
  }
`;

export const ieSubmitButtonCell = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    padding-left: ${ieCheckboxButtonPadding};
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    padding-left: ${ieCheckboxButtonPadding};

    @supports (display: grid) {
      padding-left: 0;
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const SubmitButton = styled(DhlButton)`
  width: min(100%, 345px);
  & > .styled:is(button) {
    width: 100%;
  }
`;

export const ieAddItemButtonCell = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    padding-right: 50%;
    height: 0;
    margin-top: var(--gaq-size-space-30px);
    margin-bottom: var(--gaq-size-space--30px);
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    padding-right: 50%;
    height: 0;
    margin-top: var(--gaq-size-space-30px);
    margin-bottom: var(--gaq-size-space--30px);

    @supports (display: grid) {
      padding-left: 0;
      margin-top: 0;
      margin-bottom: 0;
      padding-right: 0;
      height: auto;
      width: 100%;

      @media screen and (min-width: ${breakpoints.tablet}) {
        width: 500px;
      }
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const AddItemButtonCell = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media print {
    & > button {
      display: none;
    }
  }

  ${ieAddItemButtonCell}
`;

export const StepNoteCell = styled.div`
  @media screen and (max-width: ${breakpoints.tablet}) {
    @supports (display: grid) {
      grid-column: 12;
      white-space: nowrap;
      font-size: var(--dui-size-font-sm);
      font-weight: var(--dui-font-weight-bold);
      margin-top: var(--dui-size-space-8x);
    }
  }
`;

export const BackButtonCell = styled.div`
  ${biDimemsionalCell}
  margin-top: var(--dui-size-space-10x);
  @media screen and (max-width: ${breakpoints.tablet}) {
    order: 2;
  }
  @media screen and (min-width: ${breakpoints.tablet}) {
    align-self: start;
    order: unset;
    @supports (display: grid) {
      grid-column: 1;
      width: fit-content;
      grid-row-end: span 3;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    @supports (display: grid) {
      grid-column: 2;
    }
  }

  @media print {
    & > button {
      display: none;
    }
  }

  ${ieAddItemButtonCell}
`;

export const ieStyledIconButton = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    width: auto;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    width: 100%;

    @media screen and (min-width: ${breakpoints.tablet}) {
      width: auto;
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const StyledIconButton = styled(IconButton)`
  line-height: 1em;
  width: 100%;
  margin-top: var(--dui-size-space-5x);

  svg {
    margin-right: var(--dui-size-space-5x);
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-top: var(--dui-size-space-10x);
    padding-left: var(--gaq-size-space-52px);
    padding-right: var(--dui-size-space-10x);
    width: max-content;

    &:active,
    &:focus {
      padding-left: var(--gaq-size-space-51px);
      padding-right: var(--dui-size-space-10x);
    }

    svg {
      margin-right: 0;
      position: absolute;
      left: 25px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
  }

  ${ieStyledIconButton}
`;

export const StyledWeightSelector = styled(WeightSelector)``;

export const StyledItemCardHeader = styled.div`
  grid-template-areas: "message message close" "number total close";
  gap: var(--dui-size-space-4x);
  grid-template-columns: max-content 1fr max-content;
  display: grid;
  .message {
    grid-area: message;
  }
  .number {
    grid-area: number;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .close {
    grid-area: close;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .total {
    grid-area: total;
  }
`;
export const ItemCardWrapper = styled(FreightCardWrapper)`
  margin: var(--dui-size-space-16x) auto;
  padding: var(--dui-size-space-12x) var(--dui-size-space-20x);
  border-radius: var(--dui-size-space-6x);

  &.added-item {
    overflow: hidden;
    opacity: 0;
    animation: new-item 0.4s ease-in-out forwards;
    margin-top: var(--gaq-size-space-30px);
  }

  &.deleted-item {
    overflow: hidden;
    height: auto;
    animation: remove-item-hide 0.3s ease-in-out forwards,
      remove-item-shrink 0.3s 0.3s ease-in-out forwards;
  }
  @keyframes new-item {
    0% {
      opacity: 0;
      transform: translateY(-110%);
    }

    20% {
      opacity: 0.7;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes remove-item-hide {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes remove-item-shrink {
    0% {
      height: auto;
      padding-top: var(--gaq-size-space-29px);
      padding-bottom: var(--gaq-size-space-5px);
      margin-top: var(--gaq-size-space-30px);
      margin-bottom: ${dimensionsContentGridGap};
    }

    100% {
      height: 0;
      padding-top: 0;
      padding-bottom: 0;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`;
export const ItemCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--dui-size-space-8x);

  ${ShipmentLaneAdvancedSettings} {
    margin: 0;
  }
`;

export const StyledItemParameters = styled(GridContainer)`
  padding: 0;

  @supports (display: grid) {
    display: grid;
    grid-template-rows: [weightRow] 1fr [dimensionsRow] auto [presetsRow] auto; /* stylelint-disable-line value-keyword-case */
    grid-template-areas: "weightCol" "iconCol" "dimensionsCol" "quantityCol";
    grid-template-columns: 1fr;
    grid-row-gap: var(--dui-size-space-10x);
    ${StyledQuantityColumn} {
      ${QuantityContent} {
        margin: 0;
      }
    }
    ${StyledWeightSelector} {
      padding: 0;
      margin: 0;
    }
    ${StyledQuantityColumn} {
      grid-area: quantityCol;
    }
    ${StyledWeightSelector} {
      padding: 0;
      grid-area: weightCol;
    }
    ${CustomDimensionsWrapper} {
      grid-area: dimensionsCol;
    }

    @media screen and (min-width: ${breakpoints.tablet}) {
      grid-row-gap: 0;
      grid-template-rows: [weightRow] 1fr [dimensionsRow] auto [presetsRow] auto; /* stylelint-disable-line value-keyword-case */
      grid-column: 1 / span 12;
      grid-column-gap: var(--dui-size-space-10x);
      display: grid;
      grid-template-areas:
        "weightCol     weightCol     weightCol      weightCol    weightCol     weightCol     weightCol weightCol  weightCol   weightCol  iconCol iconCol"
        "dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol quantityCol quantityCol";
      grid-template-columns: repeat(12, 1fr);
    }
    @media screen and (min-width: ${breakpoints.desktop}) {
      grid-template-areas: "weightCol weightCol weightCol iconCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol quantityCol quantityCol";
      ${(props) =>
        props.isBusiness ? "grid-template-columns: repeat(12, 1fr);" : ""}
    }
  }

  @media print {
    display: flex;
    flex-direction: column;
  }
`;

export const ieSettingsCheckboxWrapper = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    padding-left: ${ieCheckboxButtonPadding};
    margin: var(--dui-size-space-10x) 0;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    padding-left: ${ieCheckboxButtonPadding};
    margin: var(--dui-size-space-10x) 0;

    @supports (display: grid) {
      padding-left: 0;
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const SettingsCheckboxWrapper = styled.div`
  width: 100%;
  margin: 0;
  ${biDimemsionalCell}

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: var(--dui-size-space-5x) 0 -12px;
    margin: var(--dui-size-space-5x) 0  var(--gaq-size-space--12px);

    @supports (display: grid) {
      grid-column: 7 / span 6;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin: -10px 0 -5px;

    @supports (display: grid) {
      grid-column: 8 / span 4;
    }
  }

  @media print {
    display: flex;
    flex-direction: row;
  }

  ${ieSettingsCheckboxWrapper}
`;

export const StyledCheckboxInfo = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  margin: 0;
  justify-content: space-between;
  padding: var(--dui-size-space-5x) 0 0 0;
  position: relative;
  width: 100%;

  .iconWrapper {
    position: absolute;
    right: 0;
    top: 0;
  }
  & dhl-checkbox > dhl-selection-control > div.is-disabled {
    opacity: 0.5;
  }

  label {
    height: auto !important;
    min-height: 20px !important;
  }

  input {
    /*! @noflip */
    left: -9999px;
    /*! @noflip */
    right: unset;
    position: absolute;
  }
`;

export const StyledItemIndexNumber = styled(DhlText)``;

export const StyledCloseIcon = styled(Icon)`
  transition: opacity 0.3s ease-out;
  ${(props) => (props.itemAdded ? "opacity: 1;" : "opacity: 0;")}
`;

export const StyledHiddenCloseIconContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: hidden;
  width: 50px;
  height: 50px;
`;

export const StyledHiddenCloseIcon = styled(Icon)`
  opacity: 0;
  position: absolute;
  bottom: -60px;
  right: 5px;

  &:focus {
    opacity: 1;
    bottom: 5px;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    right: 10px;

    &:focus {
      bottom: 10px;
    }
  }
`;

export const StyledTotalShipmentWeightWrapper = styled.div`
  @media screen and (min-width: ${breakpoints.tablet}) {
    white-space: nowrap;
  }
`;
export const ToolTipText = styled(DhlText)`
  & > *:is(p, span) {
    margin-bottom: ${(props) =>
      props.isParagraph ? "var(--dui-size-space-5x)" : 0} !important;
  }
`;
